(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('public-site-language', {
            parent: 'entity',
            url: '/public-site-language?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'vobeApp.publicSiteLanguage.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/public-site-language/public-site-languages.html',
                    controller: 'PublicSiteLanguageController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicSiteLanguage');
                    //$translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('public-site-language-detail', {
            parent: 'entity',
            url: '/public-site-language/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'vobeApp.publicSiteLanguage.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/public-site-language/public-site-language-detail.html',
                    controller: 'PublicSiteLanguageDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicSiteLanguage');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PublicSiteLanguage', function($stateParams, PublicSiteLanguage) {
                    return PublicSiteLanguage.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'public-site-language',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('public-site-language-detail.edit', {
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-language/public-site-language-dialog.html',
                    controller: 'PublicSiteLanguageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PublicSiteLanguage', function(PublicSiteLanguage) {
                            return PublicSiteLanguage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('public-site-language.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-language/public-site-language-dialog.html',
                    controller: 'PublicSiteLanguageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('public-site-language', null, { reload: 'public-site-language' });
                }, function() {
                    $state.go('public-site-language');
                });
            }]
        })
        .state('public-site-language.edit', {
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-language/public-site-language-dialog.html',
                    controller: 'PublicSiteLanguageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PublicSiteLanguage', function(PublicSiteLanguage) {
                            return PublicSiteLanguage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('public-site-language', null, { reload: 'public-site-language' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('public-site-language.delete', {
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-language/public-site-language-delete-dialog.html',
                    controller: 'PublicSiteLanguageDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PublicSiteLanguage', function(PublicSiteLanguage) {
                            return PublicSiteLanguage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('public-site-language', null, { reload: 'public-site-language' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
